import React, { useState } from 'react';
import { FaDownload } from 'react-icons/fa';

const months = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 5 }, (_, i) => (currentYear - i).toString());

const API_URL = process.env.REACT_APP_API_URL;

export default function DownloadZipButton({ type }) {
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');

  const handleDownload = async () => {
    if (!year || !month) {
      alert('Please select both year and month');
      return;
    }
    const endpoint =
      type === 'salaried'
        ? `${API_URL}/api/documents/download/salaried-zip?year=${year}&month=${month}`
        : `${API_URL}/api/documents/download/bvoc-zip?year=${year}&month=${month}`;
    try {
      const res = await fetch(endpoint);
      if (!res.ok) {
        let msg = 'Download failed';
        try {
          const data = await res.json();
          msg = data.message || msg;
        } catch {}
        alert(msg);
        return;
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = endpoint.includes('salaried') ? `salaried_salary_slips_${year}_${month}.zip` : `bvoc_salary_slips_${year}_${month}.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Download failed: ' + err.message);
    }
  };

  return (
    <div style={{
      margin: '1.5em 0',
      padding: '24px 28px',
      background: 'rgba(255,255,255,0.7)',
      borderRadius: 24,
      boxShadow: '0 4px 24px #22c55e11',
      display: 'flex',
      alignItems: 'center',
      gap: 20,
      justifyContent: 'center',
      flexWrap: 'wrap',
      border: '1.5px solid #e0f7fa',
      backdropFilter: 'blur(8px)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <label style={{ fontWeight: 600, color: '#22c55e', fontSize: 16 }}>Year:</label>
        <select
          value={year}
          onChange={e => setYear(e.target.value)}
          style={{
            borderRadius: 22,
            padding: '10px 24px',
            fontSize: 16,
            border: '1.5px solid #e0f7fa',
            background: '#f8fafc',
            fontWeight: 600,
            color: '#222',
            outline: 'none',
            boxShadow: '0 2px 8px #22c55e11',
            minWidth: 120,
            transition: 'border 0.18s',
            marginRight: 8,
          }}
        >
          <option value="">Select Year</option>
          {years.map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <label style={{ fontWeight: 600, color: '#22c55e', fontSize: 16 }}>Month:</label>
        <select
          value={month}
          onChange={e => setMonth(e.target.value)}
          style={{
            borderRadius: 22,
            padding: '10px 24px',
            fontSize: 16,
            border: '1.5px solid #e0f7fa',
            background: '#f8fafc',
            fontWeight: 600,
            color: '#222',
            outline: 'none',
            boxShadow: '0 2px 8px #22c55e11',
            minWidth: 140,
            transition: 'border 0.18s',
            marginRight: 8,
          }}
        >
          <option value="">Select Month</option>
          {months.map(m => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </select>
      </div>
      <button
        onClick={handleDownload}
        style={{
          borderRadius: 32,
          padding: '12px 32px',
          fontWeight: 800,
          fontSize: 18,
          background: 'linear-gradient(90deg, #22c55e 0%, #2ad2c9 100%)',
          color: '#fff',
          boxShadow: '0 2px 16px #22c55e44',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          transition: 'background 0.18s, transform 0.18s',
          outline: 'none',
          cursor: 'pointer',
          letterSpacing: 0.5,
        }}
        title={`Download ${type === 'salaried' ? 'Salaried' : 'BVOC'} ZIP`}
        onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #2ad2c9 0%, #22c55e 100%)'}
        onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #22c55e 0%, #2ad2c9 100%)'}
      >
        <FaDownload style={{ fontSize: 20 }} />
        Download {type === 'salaried' ? 'Salaried' : 'BVOC'} ZIP
      </button>
    </div>
  );
} 